import InvoiceListCard from "@legacy/invoices/components/InvoiceListCard"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"

import { CardList, Table, ViewBar, ViewMenu } from "@organisms"
import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

import { InvoiceTableViewTabs } from "@pages/Invoices/InvoiceList/views/InvoiceTableView/InvoiceTableViewTabs"

import { INVOICES_ROUTES } from "@routes/invoices"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import {
    INVOICES_LIST_CONTROLS_ACTIVE_TAB,
    INVOICES_LIST_CONTROLS_KEYWORD_SEARCH,
    INVOICES_LIST_CONTROLS_PHASE,
} from "@constants/storage"

const INVOICE_CARDS_VIEW_ATTRIBUTES = [
    { value: "client_name", label: "Client" },
    { value: "amount_due", label: "Amt. Due" },
    { value: "total", label: "Total" },
    { value: "service_name", label: "Service" },
    { value: "service_location_name", label: "Location Name" },
    { value: "service_location_address", label: "Location Address" },
    { value: "labels", label: "Labels" },
    { value: "date_due", label: "Due Date" },
    { value: "date_issued", label: "Issued" },
]

const INVOICE_CARDS_VIEW_SORT_OPTIONS = [
    { value: "id", label: "ID" },
    { value: "client_name", label: "Client" },
    { value: "status_label", label: "Status" },
    { value: "amount_due", label: "Amt. Due" },
    { value: "total", label: "Total" },
    { value: "service_name", label: "Service" },
    { value: "service_location_name", label: "Location Name" },
    { value: "service_location_address", label: "Location Address" },
    { value: "date_issued", label: "Issued" },
    { value: "date_due", label: "Due Date" },
    { value: "last_modified_at", label: "Last Modified" },
    { value: "last_viewed", label: "Seen" },
    { value: "last_sent_at", label: "Sent" },
    { value: "last_paid_at", label: "Paid" },
    { value: "last_voided_at", label: "Voided" },
    { value: "last_forgiven_at", label: "Forgiven" },
]

export default function InvoiceCardsView() {
    const [createRoute] = useSlugExtractor([INVOICES_ROUTES.CREATE])
    const { hasPermission } = useHasAccess()

    return (
        <Table.Provider
            activePhaseStorageKey={INVOICES_LIST_CONTROLS_PHASE}
            activeTabStorageKey={INVOICES_LIST_CONTROLS_ACTIVE_TAB}
            searchKeywordsStorageKey={INVOICES_LIST_CONTROLS_KEYWORD_SEARCH}
            listTitle="Invoices"
            objectType="invoice"
            objectIndexName="Invoice"
            objectName="Invoice"
            defaultActivePhase="open"
            objectCreateRoute={createRoute}
            isRowClickable={hasPermission("invoices_view_permission", PERMISSION_LEVEL.FULL)}
            isEmptyStateCreateButtonVisible={hasPermission("invoices_create_permission", PERMISSION_LEVEL.RESTRICTED)}
        >
            <CardsView.Provider
                attributes={INVOICE_CARDS_VIEW_ATTRIBUTES}
                sortOptions={INVOICE_CARDS_VIEW_SORT_OPTIONS}
            >
                <ViewBar.Root>
                    <ViewBar.Start>
                        <ViewBar.Phases>
                            <Table.Phase phase="open" title="Open" />
                            <Table.Phase phase="closed" title="Closed" />
                        </ViewBar.Phases>
                        <ViewBar.VerticalDivider />
                        <InvoiceTableViewTabs />
                    </ViewBar.Start>
                    <ViewBar.End>
                        <Table.SearchInput />
                        <ViewMenu />
                    </ViewBar.End>
                </ViewBar.Root>
                <CardList CardComponent={InvoiceListCard} />
            </CardsView.Provider>
        </Table.Provider>
    )
}
